export default __webpack_public_path__ + "static/media/warning-solid.2be40fc2.svg";